/* eslint-disable no-console */
export default function logToConsole(message, level) {
  if (level === 'fatal') {
    console.log(
      '%Warning',
      'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      message
    )
  } else if (level === 'error') {
    console.log(
      '%cError',
      'background: orange; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      message
    )
  } else if (level === 'warn') {
    console.log(
      '%Warning',
      'background: yellow; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      message
    )
  } else if (level === 'info') {
    console.log(
      '%cInfo',
      'background: cyan; color: black; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      message
    )
  } else if (level === 'debug' && process.env.NODE_ENV !== 'production') {
    console.log(
      '%cDebug',
      'background: blue; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;',
      message
    )
  }
}
